export default { // 该需求通过URL在微信中打开: 抽检管理 -》 找人帮拍 -》复制链接 -》 在微信中打开链接
  tabs: [
    {
      name: 'HelpTakePhoto',
      path: '/helpTakePhoto',
      component: () => import('./src/index.vue'),
      meta: {
        title: '抽检详情',
        isMenu: true,
        openNetwork: true
      }
    },
    {
      name: 'NotWeChat',
      path: '/notWeChat',
      component: () => import('./src/notWeChat/index.vue'),
      meta: {
        title: '抽检详情',
        openNetwork: true
      }
    },
    {
      name: 'LoseEfficacy',
      path: '/loseEfficacy',
      component: () => import('./src/loseEfficacy/index.vue'),
      meta: {
        title: '抽检详情',
        openNetwork: true
      }
    }
  ]
}
